import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { FetchMoreQueryOptions } from '@apollo/client';
import {
  JobsLandingAds as BrandImages,
  StyledImg,
}
  from '@fuww/library/src/JobsLanding';
import CompanyPage
  from '@fuww/library/src/Layouts/CompanyPage';
import TextWithImage from '../components/TextWithImage';
import Layout from '../components/Layout';
import messages from '../lib/messages.mjs';
import Head from '../components/Head';
import Hero from '../components/Hero';
import Articles from '../components/News/ArticleFeed';
import withQuery from '../lib/withQuery';
import articlesConnectionQuery
  from '../lib/queries/news/articlesConnectionQuery.graphql';
import getPartnerVariables from '../lib/getPartnerVariables';
import { useSiteContext } from '../components/SiteContext';
import { textWithImageConfigurations }
  from '../lib/imageConfigurations';
import withApollo from '../lib/apollo';
import getSourceSet from '../lib/getSourceSet';
import createCompanyBreadcrumbs from '../lib/createCompanyBreadcrumbs';
import {
  ArticlesConnectionQuery,
  ArticlesConnectionQueryVariables,
} from '../lib/graphql/api/graphql';

const companies = [
  {
    logo: 'https://fashionunited.com/global-assets/fu20164/dist/landing/images/superdry_logo.svg',
    name: 'Superdry',
  },
  {
    logo: 'https://fashionunited.com/global-assets/fu20164/dist/landing/images/hugoboss_logo.svg',
    name: 'Hugo Boss',
  },
  {
    logo: 'https://fashionunited.com/global-assets/fu20164/dist/landing/images/zalando_logo.svg',
    name: 'Zalando',
  },
  {
    logo: 'https://fashionunited.com/global-assets/fu20164/dist/landing/images/adidas_logo.svg',
    name: 'Adidas',
  },
];
// 'https://r.fashionunited.com/ykzP8kBERIwJvkMm1uYl7zO8K8wrQGa9-9ryF41-W6s/resize:fill:42:0:0/gravity:ce/quality:70/aHR0cHM6Ly9ibG9nYnVja2V0LmZhc2hpb251bml0ZWQuY29tL2NvbXBhbnkvZW1wbG95ZXJfYnJhbmRpbmdfaW1hZ2UucG5n',

const imageUrls = {
  employerBranding: [
    'https://r.fashionunited.com/ykzP8kBERIwJvkMm1uYl7zO8K8wrQGa9-9ryF41-W6s/resize:fill:42:0:0/gravity:ce/quality:70/aHR0cHM6Ly9ibG9nYnVja2V0LmZhc2hpb251bml0ZWQuY29tL2NvbXBhbnkvZW1wbG95ZXJfYnJhbmRpbmdfaW1hZ2UucG5n',
    'https://r.fashionunited.com/zKz8GmhprYUSZRYWu5RQ3wdj-IdGizRvk9evQ7HvVAQ/resize:fill:360:0:0/gravity:ce/quality:70/aHR0cHM6Ly9ibG9nYnVja2V0LmZhc2hpb251bml0ZWQuY29tL2NvbXBhbnkvZW1wbG95ZXJfYnJhbmRpbmdfaW1hZ2UucG5n',
    'https://r.fashionunited.com/i7KjNxxYz7SsKoHBDUPdql9DywEWx3PCYkIsz57_7Aw/resize:fill:460:0:0/gravity:ce/quality:70/aHR0cHM6Ly9ibG9nYnVja2V0LmZhc2hpb251bml0ZWQuY29tL2NvbXBhbnkvZW1wbG95ZXJfYnJhbmRpbmdfaW1hZ2UucG5n',
    'https://r.fashionunited.com/4NIs9h2G-pSuIuWpzo1-4zGDQO_ttJlmI3WMTsXKSHk/resize:fill:920:0:0/gravity:ce/quality:70/aHR0cHM6Ly9ibG9nYnVja2V0LmZhc2hpb251bml0ZWQuY29tL2NvbXBhbnkvZW1wbG95ZXJfYnJhbmRpbmdfaW1hZ2UucG5n',
  ],
  displayAdvertising: [
    'https://r.fashionunited.com/-9UmLEOGF72SBlJeLNV8Fyu513QEUgILYdr-8U0klgM/resize:fill:42:0:0/gravity:ce/quality:70/aHR0cHM6Ly9ibG9nYnVja2V0LmZhc2hpb251bml0ZWQuY29tL2NvbXBhbnkvZGlzcGxheV9hZHZlcnRpc2luZ19pbWFnZS5wbmc',
    'https://r.fashionunited.com/SUdbI6Q-IcE3w-pULhExJXtxy_C0Dx77yYxkfz1nYew/resize:fill:360:0:0/gravity:ce/quality:70/aHR0cHM6Ly9ibG9nYnVja2V0LmZhc2hpb251bml0ZWQuY29tL2NvbXBhbnkvZGlzcGxheV9hZHZlcnRpc2luZ19pbWFnZS5wbmc',
    'https://r.fashionunited.com/KBEQH2q9rjR_Du92H3h09Hqv91SXYaPwGWA9Zj5mb2I/resize:fill:460:0:0/gravity:ce/quality:70/aHR0cHM6Ly9ibG9nYnVja2V0LmZhc2hpb251bml0ZWQuY29tL2NvbXBhbnkvZGlzcGxheV9hZHZlcnRpc2luZ19pbWFnZS5wbmc',
    'https://r.fashionunited.com/99S6l_T-84vFnwJrQX59TIvIBRSBZ2RhW_sCJG6FRdI/resize:fill:920:0:0/gravity:ce/quality:70/aHR0cHM6Ly9ibG9nYnVja2V0LmZhc2hpb251bml0ZWQuY29tL2NvbXBhbnkvZGlzcGxheV9hZHZlcnRpc2luZ19pbWFnZS5wbmc',
  ],
};

const logos = companies.slice(0, 4).map((image) => (
  <BrandImages key={image.name}>
    <StyledImg src={image.logo} alt={image.name} />
  </BrandImages>
));

export interface CompanyPageWithDataProperties {
  data: ArticlesConnectionQuery;
  fetchMore: (variables: FetchMoreQueryOptions<
  ArticlesConnectionQueryVariables
  >) => void;
  loading: boolean;
  variables: ArticlesConnectionQueryVariables;
}

const EmployerBranding = ({
  data,
  fetchMore,
  loading,
  variables,
}: CompanyPageWithDataProperties) => {
  const intl = useIntl();

  const breadcrumbs = createCompanyBreadcrumbs({
    intl,
    crumbRoute: 'employer-branding',
    crumbLabel: intl.formatMessage(messages['employerBranding.header']),
  });

  return (
    <>
      <Head
        title={intl.formatMessage(messages['employerBranding.header'])}
        description={intl.formatMessage(messages['employerBranding.subHeader'])}
      />
      <CompanyPage
        advertorials={(
          <Articles
            data={data}
            fetchMore={fetchMore}
            loading={loading}
            preloadFirst
            variables={variables}
          />
        )}
        breadcrumbs={breadcrumbs}
        description={intl.formatMessage(messages['employerBranding.subHeader'])}
        logos={logos}
        logosTitle={intl.formatMessage(
          messages['employerBranding.brandsHiring'],
        )}
        textWithImageComponents={(
          <>
            <TextWithImage
              buttonLabel={intl.formatMessage(messages[
                'employerBranding.buttonLabel'
              ])}
              buttonRoute="contact"
              description={intl.formatMessage(
                messages['employerBranding.ebpBody'],
              )}
              imagePosition="right"
              imageUrls={imageUrls.employerBranding}
              srcSet={getSourceSet(
                textWithImageConfigurations, imageUrls.employerBranding,
              )}
              title={intl.formatMessage(messages['employerBranding.ebpHeader'])}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(messages[
                'employerBranding.buttonLabel'
              ])}
              buttonRoute="contact"
              description={intl.formatMessage(
                messages['employerBranding.advertorialsBody'],
              )}
              imagePosition="left"
              imageUrls={imageUrls.displayAdvertising}
              srcSet={getSourceSet(
                textWithImageConfigurations, imageUrls.displayAdvertising,
              )}
              title={intl.formatMessage(
                messages['employerBranding.advertorialsHeader'],
              )}
            />
          </>
        )}
        title={intl.formatMessage(messages['employerBranding.header'])}
      />
    </>
  );
};

const EmployerBrandingWithQuery = withQuery<
ArticlesConnectionQuery,
ArticlesConnectionQueryVariables
>(EmployerBranding);

const EmployerBrandingPage: NextPageWithLayout = () => {
  const { newsboard } = useSiteContext();

  return (
    <EmployerBrandingWithQuery
      errorMessage="Error while loading news articles"
      query={articlesConnectionQuery}
      variables={getPartnerVariables(newsboard)}
    />
  );
};

EmployerBrandingPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        alt="Employer branding banner image"
      />
    )}
  >
    {page}
  </Layout>
);

export default withApollo(EmployerBrandingPage);
